import QRCode from 'react-qr-code';
import styled from 'styled-components';
import { CountdownTimer } from './CntTimer';
import { qrStore } from '../../store/qrStore';
import { useApiHook } from '../../hook/useApiHook';
import { useEffect } from 'react';
import { infoStore } from '../../store/infoStore';
import { getQrUrl, mobileQuery } from '../../utils';
import { ImageUtils } from '../../utils/ImageUtils';

export const QrTicket = ({ isMainEvent = true }: { isMainEvent?: boolean }) => {
  const { mainInfo, sideInfo } = infoStore();
  const info = isMainEvent ? mainInfo : sideInfo;

  const { getMainQr, getSideQr } = useApiHook();
  const getQr = isMainEvent ? getMainQr : getSideQr;

  const store = qrStore();
  const qrData = isMainEvent ? store.mainQrData : store.sideQrData;

  useEffect(() => {
    getQr();
  }, [getQr]);

  return (
    <Container>
      <Ticket src={isMainEvent ? ImageUtils.CardMain : ImageUtils.CardSide}></Ticket>
      <TicketTextContainer>
        <Title>오프라인 {isMainEvent ? '메인' : '사이드'} 이벤트 참가 정보</Title>
        <Inner>
          <LeftItem>
            <NumberTitleContainer>
              <NumberTitle>참가자 번호</NumberTitle>
            </NumberTitleContainer>
            <TicketText>{info.ticketNo}</TicketText>
          </LeftItem>

          <RightItem>
            <QrArea>
              <Qr value={getQrUrl(qrData.qrHash || '', isMainEvent)}></Qr>
            </QrArea>
            {qrData.createDate && (
              <ExpandTextContainer>
                <ExpandText>
                  <CountdownTimer initialTime={qrData.createDate} />
                  <UnderLine onClick={getQr}>유효시간 연장하기</UnderLine>
                </ExpandText>
              </ExpandTextContainer>
            )}
          </RightItem>
        </Inner>
      </TicketTextContainer>
    </Container>
  );
};

const Ticket = styled.img`
  position: relative;

  ${mobileQuery} {
    width: 330px;
  }
`;

const Title = styled.h3`
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.6);
  margin-top: 13px;
  margin-bottom: 9px;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 16px;
    margin-top: 10px;
    margin-bottom: 15px;
  }
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 32px;
  padding-right: 27px;
  margin-top: 20px;

  ${mobileQuery} {
    padding-left: 40px;
    padding-right: 14px;
    margin-top: 0px;
  }
`;

const LeftItem = styled.div`
  width: 357px;
  margin-right: 24px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);

  ${mobileQuery} {
    margin-right: 12px;
  }
`;

const RightItem = styled.div`
  flex: 1;
`;

const NumberTitleContainer = styled.div`
  height: 56px;
  margin: 0 auto;

  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;

  ${mobileQuery} {
    height: 28px;
  }
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  font-size: 24px;
  line-height: 56px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 28px;
  }
`;

const Container = styled.div`
  position: relative;
  overflow-x: hidden;
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

const Qr = styled(QRCode)`
  position: relative;
  width: 180px;
  height: 160px;

  ${mobileQuery} {
    width: 95px;
    height: 90px;
  }
`;

const QrArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  width: 200px;
  height: 200px;
  position: relative;

  ${mobileQuery} {
    width: 100px;
    height: 100px;
  }
`;

const ExpandTextContainer = styled.div`
  position: absolute;
  bottom: -30px;
  width: 100%;

  ${mobileQuery} {
    bottom: -20px;
  }
`;

const ExpandText = styled.h3`
  font-size: 20px;
  color: #ff0000;
  letter-spacing: -0.2px;
  font-family: 400;

  ${mobileQuery} {
    font-size: 10px;
  }
`;

const UnderLine = styled.span`
  text-decoration: underline;
  margin-left: 3px;
`;

const TicketText = styled.p`
  font-weight: bold;
  font-weight: 700;
  font-size: 128px;
  line-height: 144px;
  color: #000000;
  text-align: center;

  ${mobileQuery} {
    font-size: 64px;
    line-height: 69px;
  }
`;
